import { createSlice } from '@reduxjs/toolkit'
import { postTag, getConsumerTagsWithData } from '..'
import { ConsumerTag } from '../../model'
import { isValidObject } from '../../utils/object'

export interface TagsState {
  active: string[]
  consumerTag: ConsumerTag
}

export const tagsInitialState: TagsState = {
  active: [],
  consumerTag: {},
}

const slice = createSlice({
  name: 'tags',
  initialState: tagsInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postTag.pending, (state, action) => {
        if (!state.active.includes(action.meta.arg.name)) {
          state.active = state.active.concat(action.meta.arg.name)
        }
      })
      .addCase(postTag.rejected, (state, action) => {
        state.active = state.active.filter((tag) => tag !== action.meta.arg.name)
      })
      .addMatcher(getConsumerTagsWithData.matchFulfilled, (state, action) => {
        state.consumerTag = action.payload
        state.active = isValidObject(action.payload) ? Object.keys(action.payload) : []
      })
  },
})

export default slice.reducer
